export const globalAppCache = {
  userCache: {}, // Stores user details by userId
  layoutCache: { data: null, timestamp: 0 }, // Stores table layout
};
